<template>
	<div
		class="new-message-button-wrapper"
		:style="{ top: 80 + 'px', left: left }"
	>
		<div class="new-message-button">
			<div class="new-message-up-arrow">
				<SpinnerOverlay
					v-if="newMessageLoader"
					cBackground="#01DAB6"
					sColor="#ffffff"
					sHeight="25px"
					sWidth="25px"
					cTop="7px"
					cLeft="7px"
					style="
						position: unset !important;
						margin: -4px -2px 3px -5px !important;
					"
				/>
				<img v-if="!newMessageLoader" src="/images/common/up-arrow-white.svg" />
			</div>

			<div class="new-message-text">
				{{
					$t(
						'chat_unreadbanner_newmessages.variable',
						[messageCount],
						messageCount
					)
				}}
			</div>
			<div
				class="new-message-dismiss"
				:aria-label="$t('common_button_close')"
				@click.stop="dismissNotification"
			>
				<img src="/images/common/close-x-white.svg" />
			</div>
		</div>
	</div>
</template>

<script>
import store from '../store'
import SpinnerOverlay from './SpinnerOverlay'
import { MAX_UNREADS, UNREAD_LABEL } from '@/helpers/constants'

export default {
	components: { SpinnerOverlay },
	props: ['message_num', 'newMessageLoader'],
	data() {
		return {
			store,
		}
	},

	emits: ['dimiss'],

	computed: {
		left() {
			return (
				'calc(50% + ' + (25 - this.message_num.toString().length * 5) + 'px)'
			)
		},

		messageCount() {
			return this.message_num >= MAX_UNREADS ? UNREAD_LABEL : this.message_num
		},
	},

	methods: {
		dismissNotification() {
			this.$emit('dismiss')
		},
	},
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 800px) {
	.new-message-button-wrapper {
		left: calc(50% - 100px) !important;
	}
}

.new-message-button-wrapper {
	position: absolute;
	cursor: pointer;
	z-index: 2;
}

.new-message-button {
	position: relative;
	margin: 0 auto;
	background: #01dab6;
	font-family: Avenir-Heavy;
	font-size: 14px;
	color: #ffffff;
	height: 36px;
	border-radius: 18px;
	display: flex;
	align-items: center;
	overflow: hidden;
}

.new-message-text {
	margin: 0 5px;
	flex-grow: 1;
}

.new-message-up-arrow {
	margin: 4px 8px;
	height: 18px;
}

.new-message-dismiss {
	padding: 11px 12px 11px 8px;
	height: 36px;
	&:hover {
		background: #10c7aa;
	}
	> img {
		width: 14px;
		height: 14px;
	}
}
</style>
